import { useLocale } from "next-intl";
import { usePrefetchQuery, useQuery } from "@tanstack/react-query";

import { getFavoriteLeagues } from "@/api/leaguesNew";

export enum FavoriteLeaguesQueryKeys {
  All = "leaguesNew.favorite",
}

interface GetLeaguesOptions {
  name?: string;
  popular?: boolean;
  sportId?: number;
}

const createFavoriteLeaguesQuery = (locale: string, options: GetLeaguesOptions = {}) => ({
  queryKey: [FavoriteLeaguesQueryKeys.All, locale, options.sportId],
  queryFn: ({ signal }: { signal?: AbortSignal }) => {
    const params = { lang: locale, ...options };
    return getFavoriteLeagues({ params, signal });
  },
});

export const useFavoriteLeagues = (options: GetLeaguesOptions = {}) => {
  const locale = useLocale();
  return useQuery(createFavoriteLeaguesQuery(locale, options));
};

export const usePrefetchFavoriteLeagues = () => {
  const locale = useLocale();
  return usePrefetchQuery(createFavoriteLeaguesQuery(locale));
};
